var React = require('react');

function FacebookIcon (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("g",{"clipPath":"url(#clip-F4B30594-3AB8-4532-9C80-8FAAA649B2CC)"},React.createElement("path",{"fill":"currentColor","d":"M14.873.19c8.214 0 14.873 6.647 14.873 14.843 0 8.198-6.659 14.843-14.873 14.843C6.659 29.876 0 23.23 0 15.033 0 6.837 6.66.19 14.873.19zm4.272 11.548h-2.91V9.83c0-.714.474-.882.809-.882h2.053V5.804l-2.827-.01c-3.138 0-3.853 2.344-3.853 3.845v2.099h-1.815v3.238h1.815v9.171h3.818v-9.171h2.575z"}))));
}

FacebookIcon.defaultProps = {"viewBox":"0 0 30 30"};

module.exports = FacebookIcon;

FacebookIcon.default = FacebookIcon;
